import * as React from 'react';
import Button from '../Button/Button.js';

const ToggleGroup = ({ name , options , onClick , initialValue  })=>{
    const [selectedOption, setSelectedOption] = React.useState(()=>{
        if (initialValue !== undefined) {
            return options.find((option)=>option.value === initialValue
            );
        }
        return undefined;
    });
    const handleClick = (option)=>{
        const newSelectedOption = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value ? undefined : option;
        setSelectedOption(newSelectedOption);
        onClick(newSelectedOption);
    };
    return /*#__PURE__*/ React.createElement("div", {
        role: "group",
        className: "toggle-group",
        "data-t": "toggle-group"
    }, options.map((option, index)=>{
         return React.createElement(Button, {
            variant: "barebones",
            className: "toggle-group__option",
            key: index,
            caption: option.label,
            onClick: ()=>handleClick(option)
            ,
            "aria-pressed": (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value
        });
    }), /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: name,
        value: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || ''
    }));
};

export { ToggleGroup as default };
//# sourceMappingURL=ToggleGroup.js.map
